import { Component } from 'solid-js'
import { userStore } from '../../../store/user'
import SimpleModal from '../SimpleModal'

export const NoTokensModal: Component = () => {
  const state = userStore()

  return (
    <SimpleModal show={state.showNoTokensModal} onClose={() => userStore.showNoTokensModal(false)}>
      <div class="relative mx-auto flex max-w-md flex-col items-center justify-center rounded-2xl bg-gradient-to-tr from-purple-600 to-blue-600 p-6 shadow-2xl">
        {/* Info Icon */}
        <div class="absolute left-5 top-2 flex items-center">
          <span class="text-xl">ⓘ</span>
        </div>
        {/* Close Button */}
        <button
          class="absolute right-4 top-1 text-4xl text-white hover:opacity-70"
          onClick={() => userStore.showNoTokensModal(false)}
          aria-label="Close"
        >
          ×
        </button>
        {/* Message */}
        <div class="mb-4 mt-5 text-left text-lg leading-snug">
          Uh-oh! Looks like you're out of tokens&nbsp; but don't worry, you're just a step away from
          getting back to the fun!
        </div>
        {/* Add Tokens Button */}
        <button
          class="w-full rounded-xl border border-white bg-transparent py-3 text-xl font-bold text-white transition hover:bg-white hover:text-[#a259ff]"
          onClick={() => {
            userStore.showNoTokensModal(false)
            userStore.buyTokensModal(true)
          }}
        >
          Add Tokens
        </button>
      </div>
    </SimpleModal>
  )
}
